import Gobalstore from "../index";
export const actions = {
  getIncome: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/reporting/income`,
      data: payload
    })
      .then(function (response) {
        localStore.commit("setIncome", response.data);
        Gobalstore.commit("LoadingOverlay", false);
        return response;
      })
      .catch((error) => {
        Gobalstore.commit("LoadingOverlay", false);
        return error;
      });
  },

  exportIncome: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/reporting/export-income`,
      data: payload,
      responseType: "arraybuffer",
    })
      .then(function (response) {
        Gobalstore.commit("LoadingOverlay", false);
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "income_report.xlsx");
        document.body.appendChild(link);
        link.click();
        return response;
      })
      .catch((error) => {
        Gobalstore.commit("LoadingOverlay", false);
        return error;
      });
  },


  getApprove: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "POST",
      url: `/admin/guarded/reporting/approved`,
      data: payload,
    })
      .then(function (response) {
        localStore.commit("setApproved", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
  getCompany: function (localStore, tin) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/reporting/companies?tin=${tin}`,
    })
      .then(function (response) {
        localStore.commit("setCompany", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
  getReportentreaties: function (localStore, { year, stt }) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/entreaties?year=${year}&stage=${stt}`,
    })
      .then(function (response) {
        if (stt == "PENDING") {
          let noRevoke = [...response.data].filter(
            (e) => e.ent_status.to_status_code !== "REVOKE"
          );
          localStore.commit("setentreaties", noRevoke);
        } else {
          localStore.commit("setentreaties", response.data);
        }
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
};
